import axios, { AxiosResponse } from 'axios';
import { ICareTeam } from '../../../Models/CareTeams/CareTeam.model';
import { apiString } from '../../../utils/constants';

export const addCareTeam = async (careTeam: ICareTeam): Promise<AxiosResponse<ICareTeam>> => {
    return axios.post<ICareTeam>(`${apiString}/careTeams`, careTeam);
};

export const updateCareTeam = async (careTeam: ICareTeam): Promise<AxiosResponse<ICareTeam>> => {
    return axios.put<ICareTeam>(`${apiString}/careTeams/${careTeam.Id}`, careTeam);
};

export const fetchCareTeams = async (includeSoftDeleted: boolean = false): Promise<AxiosResponse<ICareTeam[]>> => {
    return axios.get<ICareTeam[]>(`${apiString}/careTeams/getallcareteams?includeSoftDeleted=${includeSoftDeleted}`);
};

export const deleteCareTeam = async (id: string): Promise<AxiosResponse<void>> => {
    return axios.delete<void>(`${apiString}/careTeams/${id}`);
};

export const fetchCurrentUserCareTeam = async (): Promise<AxiosResponse<ICareTeam[]>> => {
    return axios.get<ICareTeam[]>(`${apiString}/careTeams/GetCurrentUserCareTeams`);
};

export const getMemberCareTeam = async (memberId: string): Promise<AxiosResponse<ICareTeam | null>> => {
    return axios.get<ICareTeam | null>(`${apiString}/careTeams/GetMemberCareTeam?memberId=${memberId}`);
};

export const fetchCareTeamById = async (teamId: string): Promise<AxiosResponse<ICareTeam>> => {
    return axios.get<ICareTeam>(`${apiString}/careTeams/${teamId}`);
};
